import { CommonFormFields } from "commons/Forms/formsComponents/formTypes";
import ServiceAirTree from "services/airTree";

export const AirTreeFormFields = (props) => {
  const loadDefaultValuesByType = (val, fieldIndex = null) => {
    props?.updateFieldsFromType(val, fieldIndex);
  };

  const updateLai = (val, fieldIndex = null) => {
    props?.updateFieldLai(val, fieldIndex);
  };

  const updateDepth = (val, fieldIndex = null) => {
    props?.updateFieldDepth(val, fieldIndex);
  };

  // Form Fields type point and line
  const FieldsShape = () => {
    let areaFields = [];
    for (let index = 0; index < 3; index++) {
      const incrementedIndex = index + 1;
      areaFields[index] = {
        name: `area_${incrementedIndex}`,
        type: "group",
        containerProps: {
          title: `Specie ${incrementedIndex}`,
          id: `specie${incrementedIndex}`,
        },
        fields: [
          {
            name: `area_${incrementedIndex}.type_cover_percent`,
            label:
              "Copertura percentuale specie (la copertura totale delle 3 specie non deve superare il 100%)",
            type: "number",
            required: incrementedIndex === 1 ?? true,
            min: 1,
            max: 100,
            span: 24,
          },
          {
            name: `area_${incrementedIndex}.type`,
            label: "Specie a cui appartiene l’albero",
            type: "select_remote",
            onChange: (value) =>
              loadDefaultValuesByType(value, incrementedIndex),
            showAll: true,
            required: incrementedIndex === 1 ?? true,
            placeholder: "Seleziona una specie arborea",
            span: 8,
            service: (q) => {
              return ServiceAirTree.treeTypes();
            },
          },
          {
            name: `area_${incrementedIndex}.dbh`,
            label: "Diametro fusto a petto d’uomo (cm)",
            type: "number",
            min: 1,
            width: "10%",
            onChange: (value) => updateLai(value, incrementedIndex),
            span: 24,
          },
          {
            name: `area_${incrementedIndex}.crownwidth`,
            label: "Diametro della chioma (m)",
            type: "number",
            min: 1,
            span: 24,
          },
          {
            name: `area_${incrementedIndex}.height`,
            label: "Altezza albero (m)",
            type: "number",
            min: 1,
            onChange: (value) => updateDepth(value, incrementedIndex),
            span: 24,
          },
          {
            name: `area_${incrementedIndex}.canopy_cover`,
            label: "Percentuale copertura chioma (canopy cover)",
            type: "number",
            min: 1,
            span: 24,
          },
          {
            name: `area_${incrementedIndex}.lai`,
            label: "Indice Area Fogliare (LAI)",
            type: "number",
            span: 24,
          },
          {
            name: `area_${incrementedIndex}.depth`,
            label: "Profondità della chioma (m)",
            type: "number",
            span: 24,
          },
        ],
      };
    }
    return areaFields;
  };

  // Form Fields type point and line
  const Fields = [
    {
      name: "type",
      label: "Specie a cui appartiene l’albero",
      type: "select_remote",
      onChange: (value) => loadDefaultValuesByType(value),
      showAll: true,
      required: true,
      placeholder: "Seleziona una specie arborea",
      span: 8,
      service: (q) => {
        return ServiceAirTree.treeTypes();
      },
    },
    {
      name: "dbh",
      label: "Diametro fusto a petto d’uomo (cm)",
      type: "number",
      min: 1,
      width: "10%",
      onChange: (value) => updateLai(value),
      span: 24,
    },
    {
      name: "crownwidth",
      label: "Diametro della chioma (m)",
      type: "number",
      min: 1,
      span: 24,
    },
    {
      name: "height",
      label: "Altezza albero (m)",
      type: "number",
      min: 1,
      onChange: (value) => updateDepth(value),
      span: 24,
    },
    ...(props?.type === 2
      ? [
          {
            type: "radio",
            label:
              "Indicare il numero di alberi o la distanza tra un albero e il succssivo",
            name: "tree_number_or_distance",
            required: true,
            // @ts-ignore
            showAsButtons: true,
            options: [
              { label: "Num. alberi", value: 1 },
              { label: "Distanza tra alberi", value: 2 },
            ],
            span: 12,
          },
          {
            name: "number_of_trees",
            label: "Numero alberi",
            type: "number",
            min: 1,
            span: 24,
            conditions: {
              visibleIf: {
                name: "tree_number_or_distance",
                value: 1,
              },
            },
          },
          {
            name: "distance_of_trees",
            label: "Distanza tra alberi (m)",
            type: "number",
            min: 1,
            span: 24,
            conditions: {
              visibleIf: {
                name: "tree_number_or_distance",
                value: 2,
              },
            },
          },
        ]
      : []),
    // ...(props?.type === 3 ? [{
    //     name: 'canopy_cover',
    //     label: 'Percentuale copertura chioma (canopy cover)',
    //     type: 'number',
    //     min: 1,
    //     span: 24
    // }] : []),
    {
      name: "lai",
      label: "Indice Area Fogliare (LAI)",
      type: "number",
      span: 24,
    },
    {
      name: "depth",
      label: "Profondità della chioma (m)",
      type: "number",
      span: 24,
    },
  ];

  return props?.type === 3 ? FieldsShape : Fields;
};
